import { render, staticRenderFns } from "./Selectlist.vue?vue&type=template&id=2ebad193&scoped=true&"
import script from "./Selectlist.vue?vue&type=script&lang=js&"
export * from "./Selectlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebad193",
  null
  
)

export default component.exports